/**
 * Display-name resolution for original creditor on portal detail surfaces
 * (Account Background, Account Details, Disclosures) and the jurisdictional
 * Account Origin eyebrow.
 *
 * Precedence:
 *   1. Persist-enriched / Interprose `originalCreditorName` on account
 *   2. Interprose / legacy disclosure `originalCreditorName`
 *   3. Interprose `clientName` (last resort — often a seller/client label)
 */
export const resolveOriginalCreditorDisplayName = (
  account = {},
  disclosure = {}
) => {
  const candidates = [
    account.originalCreditorName,
    account.itemizationCreditorName,
    disclosure.originalCreditorName,
    account.clientName,
  ];

  for (const value of candidates) {
    if (value === undefined || value === null) continue;
    const normalized = String(value).trim();
    if (normalized) return normalized;
  }

  return '';
};

/**
 * Creditor name for the jurisdictional Account Origin eyebrow only.
 * Prefers dedicated original-creditor fields; never uses `clientName`, which
 * can be a portfolio/client label rather than the underwriting creditor.
 */
export const resolveAccountOriginEyebrowCreditorName = (
  account = {},
  disclosure = {}
) => {
  const candidates = [
    account.originalCreditorName,
    account.itemizationCreditorName,
    disclosure.originalCreditorName,
  ];

  for (const value of candidates) {
    if (value === undefined || value === null) continue;
    const normalized = String(value).trim();
    if (normalized) return normalized;
  }

  return '';
};
